export default "<img ng-class=\"::$ctrl.style.paymentMethodIcon\" ng-src=\"{{$ctrl.iconFileUrl}}\" />\n"